import jssocials from 'jssocials';

jsSocials.shares.twitter = {
    label: "Tweet",
    logo: "icon-twitter",
    shareUrl: "https://twitter.com/share?url={url}&text={text}&via={via}&hashtags={hashtags}",
    countUrl: "https://cdn.api.twitter.com/1/urls/count.json?url={url}&callback=?",
    getCount: function(data) {
        return data.count;
    }
}
jsSocials.shares.pinterest = {
    label: "Pin it",
    logo: "icon-pinterest",
    shareUrl: "https://pinterest.com/pin/create/bookmarklet/?media={media}&url={url}&description={text}",
    countUrl: "https://api.pinterest.com/v1/urls/count.json?&url={url}&callback=?",
    getCount: function(data) {
        return data.count;
    }
}
jsSocials.shares.facebook = {
    label: "Like",
    logo: "icon-facebook",
    shareUrl: "https://facebook.com/sharer/sharer.php?u={url}",
    countUrl: "https://graph.facebook.com/?id={url}",
    getCount: function(data) {
        return data.share && data.share.share_count || 0;
    }
}
jsSocials.shares.googleplus = {
    label: "+1",
    logo: "icon-uniF1A0",
    shareUrl: "https://plus.google.com/share?url={url}",
    countUrl: ""
}
jsSocials.shares.linkedin = {
    label: "Share",
    logo: "icon-linkedin",
    shareUrl: "https://www.linkedin.com/shareArticle?mini=true&url={url}",
    countUrl: "https://www.linkedin.com/countserv/count/share?format=jsonp&url={url}&callback=?",
    getCount: function(data) {
        return data.count;
    }
}

$("#momentos_share").jsSocials({
    showLabel: false,
    showCount: false,
    shares: ["facebook", "twitter", "googleplus"]
});

$("#post_share").jsSocials({
    showLabel: false,
    showCount: false,
    shares: ["facebook", "twitter", "googleplus"]
});


function _viewMore(uri, params, id, item) {
    $.ajax({
        url: uri,
        dataType: 'html',
        data: params,
        type: 'POST',
        success: function(response) {
            item.remove();
            $(id).append(response);
        }
    });
}

$(function() {
    $('body #ofertas_disponibles').on('click', '#ver_mas_ofertas a#view_more', function(e) {
        e.preventDefault();
        var item = $(this);
        var params = {
            pagina: item.data('page')
        };
        _viewMore('/views/layouts/components/_ofertas_disponibles.php', params, '#ofertas_disponibles', item);
    });

    $('body #blog').on('click', '#ver_mas_ofertas a#view_more', function(e) {
        e.preventDefault();
        var item = $(this);

        var params = {
            pagina: item.data('page')
        };
        _viewMore('/views/layouts/components/_blog.php', params, '#blog', item);
    });

    $('body #ofertas_disponibles').on('click', 'figure > div.img__grid > .content', function(e) {
        e.preventDefault();
        var momento = $(this).data('id');
        if (momento != 0) {
            window.open('/moments/moment/' + momento, '_blank');
        }
    });


    /* --------------------------------------------------
    Botón de retorno al Top
    -------------------------------------------------- */
    var offset = 250,
        scrollDuration = 300;
    $(window).scroll(function() {
        if ($(this).scrollTop() > offset) {
            $('.top').fadeIn(500);
        } else {
            $('.top').fadeOut(500);
        }
    });


    $('.top').click(function(event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, scrollDuration);
    });

    /*---------------------------------------------------
    Cokkies
    ---------------------------------------------------*/
    $.cookiesDirective({
        duration: 50,
        privacyPolicyUri: 'politicacookies',
        explicitConsent: false,
        position: 'bottom',
        backgroundColor: '#f7a700',
        linkColor: '#ffffff'
    });
    $("#impliedsubmit").css("color", "#ffffff !important");

    /*---------------------------------------------------
    Página - Grupo AVA 
    ---------------------------------------------------*/
    $('.grupo_ava').click(function(e) {
        e.preventDefault();
        var $active = $(this);
        var page = $active.data('page');

        $('.grupo_ava').each(function() {
            $(this).removeClass('active');
        });
        $active.addClass('active');


        $.ajax({
            url: '/views/layouts/components/_' + page + '.php',
            dataType: 'html',
            type: 'POST',
            success: function(response) {
                $('#content_grupo').html(response);
            }
        });
    });
});


// WEBPACK FOOTER //
// ./assets/js/custom.js